export const regexPassword =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/

export const getFeeCategoryDisplayName = (feeCategory) => {
  if (feeCategory === "Merit Higher Fee") return "Merit Full Fee";
  if (feeCategory === "Merit Lower Fee") return "Merit Low Fee";
  return feeCategory;
};
